// Built-in import
import * as React from "react";

// External import
import { Stack, Typography, alpha } from "@mui/material";

import { IServerProperty } from "@/store/slices/property";
import { useTranslation } from "react-i18next";

interface IProjectProfitProps {
  item: IServerProperty;
}

const ProjectProfit: React.FC<IProjectProfitProps> = ({ item }) => {
  // Getting translation object
  const { t } = useTranslation(["common"]);
  return (
    <Stack
      direction="row"
      justifyContent={"space-between"}
      flexWrap="wrap"
      sx={{
        background: (t) => alpha(t.palette.primary.main, 0.2),
        p: 1.5,
        borderRadius: 1,
      }}
    >
      <Typography variant="extraSmallMedium" color="text.primary">
        {t("common:project_profit")}:
      </Typography>
      <Typography variant="smallMedium" color="text.primary">
        %<Typography component="span">{
          +item?.yearly_wage % 1 === 0
            ? Math.floor(+item?.yearly_wage)
            : +item?.yearly_wage
        }</Typography>
        <Typography component="span" color="grey.400" fontSize={13}>  {item?.period_months} ماهه </Typography>
      </Typography>
    </Stack>
  );
};

export default ProjectProfit;
